module.exports = __webpack_public_path__ + "157575062e5c8bde5b15126a62f45f46.png";